import {RoleStatusMessage} from "./status-message";

export class RoleStatus {
  public active: boolean;
  public destinations: any[];
  public statusMessages: RoleStatusMessage[];
  public id: string;
  public name: string;
  public sortNumber: number;
  public roleId: string;
  public roleStatusType: string;
  public rejectionCatalogId: string;
}
